module.exports = __webpack_public_path__ + "static/media/calendar.baf2d4af.svg";